import { Box, Fade, useMediaQuery } from '@mui/material';

import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import {
  getActiveTab,
  // getCarHotSpotCardOpen,
  getCarStatus,
  getExteriorZoomScale,
} from '../../store/car-slice';
import FloatButtons from './float-buttons';
import NavigationBar from '../navigation-bar/navigation-bar';
import CloseButton from './close-button';

const Buttons = () => {
  // Selectors
  const activeTab = useSelector(getActiveTab);
  const carStatus = useSelector(getCarStatus);
  // const carHotSpotCardOpen = useSelector(getCarHotSpotCardOpen);
  const exteriorZoomScale = useSelector(getExteriorZoomScale);
  // Media Queries
  const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));
  // const isLandscape = useMediaQuery('(orientation: landscape)');

  const showClose = activeTab !== 'gallery' && exteriorZoomScale === 1;
  const showFloatButtons = activeTab === 'exterior' && exteriorZoomScale === 1;

  return (
    <>
      {carStatus === 'CAR' && (
        <Fade in={showClose}>
          <Box>
            <CloseButton />
          </Box>
        </Fade>
      )}
      {carStatus === 'CAR' && isDesktop && (
        <Fade in={showFloatButtons}>
          <Box>
            <FloatButtons />
          </Box>
        </Fade>
      )}
      <NavigationBar />
    </>
  );
};

export default memo(Buttons);
